import React, {
  Fragment,
  useEffect,
  useRef,
  useState,
} from "react";
import { Col, Container, Row } from "react-bootstrap";
import Image from "lib/Image";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL } from "constants/routes";
import {
  getCommentsByWorkFlowId,
  addComment,
  uploadAttachmentOfComments,
  uploadCommentDocument,
  editCommentById,
  deleteAttachments,
} from "api/comments";
import {
  deleteAnUploadedFileFromAttachment,
  resetAddedNewComment,
  resetCommentsState,
  setdeleteAttachedComment,
  updateAttachments,
  setSelectedCommentAttachment,
  clearSelectedComment,
  clearUploadedListAttachmentOfComments,
  reseteditCommenttoaster
} from "redux/commentsReducer";
import {
  setUsersSuggestionsList
} from "redux/usersReducer"
import Spinner from "react-bootstrap/Spinner";
import ImageModal from "lib/DocumentViewer/Modal/ImageModal";
// import { useParams } from "react-router-dom";
import Toast from "components/ToastComponent";
import CommentMsg from "components/CommentMessageConatiner/CommentMsg";
import UploadFile from "assets/images/UploadFile.png";
import Send2x from "assets/images/Send2x.png";
import { getActivityListByWorkFlowID } from "api/activity";
import { resetActivityListState } from "redux/activityListReducer";
import { getUserFromUsersList } from "helper/common";
import { debounceFunc } from "helper";
import { resetdeleteCommenttoaster } from "redux/commentsReducer";
import Modal from "lib/DocumentViewer/Modal";

const CommentTextArea = (props) => {
  // const params = useParams();
  const params = useSelector((state) => state?.urlEncryption?.urlParams);
  const moduleId = useSelector((state) => state?.dashboardDetailReducer?.dashboardDetailConfiguration?.configurationInfo?.module_id);
  // const [usersList, setUsersList] = useState([]);
  const [triggerText, setTriggerText] = useState("");
  const [showSuggestion, setShowSuggestion] = useState(false);
  const [suggestionTextPos, setSuggestionTextPos] = useState({
    start: "",
    end: "",
  });
  // const [loading, setLoading] = useState(false);
  const [inputFileValue, setFileValue] = useState({});
  const [uploadedList, setUploadedList] = useState([]);
  const [mentionsList, setMentionsList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [checkcomments, setcheckcomments] = useState(false)
  const [commentList, setCommentList] = useState([]);
  const [imageSource, setImageSource] = useState("");
  const [original_filename, setOrginalFileName] = useState("");
  const [isemptyComment, setIsEmptyComment] = useState(false);
  const [isEditComment, setIsEditComment] = useState(false);
  const timerRef = useRef(null);
  const [charCount, setCharCount] = useState(0);
  const [imgSrc, setimgSrc] = useState();
  const maxChars = props?.maxChars || 500;
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const workflow_id = params?.primaryWorkflowId;
  const [isPdf, setisPdf] = useState(false);
  const organisation_id = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo
  ).organisationInfo?._id;
  const comments = useSelector((state) => state?.commentsReducer?.comments);
  const start = useSelector((state) => state?.commentsReducer?.start);
  const limit = useSelector((state) => state?.commentsReducer?.limit);
  const totalComments = useSelector((state) => state?.commentsReducer?.total);
  const sortBy = useSelector((state) => state?.commentsReducer?.sortBy);
  const sortOrder = useSelector((state) => state?.commentsReducer?.sortOrder);
  const loadingComments = useSelector((state) => state?.commentsReducer?.loading);
  const uploadedListAttachmentOfComments = useSelector((state) => state?.commentsReducer?.uploadedListAttachmentOfComments);
  const isUploadAttachmentOfCommentsLoading = useSelector((state) => state?.commentsReducer?.isUploadAttachmentOfCommentsLoading);
  const usersSuggestionList = useSelector((state) => state?.usersReducer?.usersSuggestionList);
  const allUsers = useSelector((state) => state?.dashboardReducer?.allUsers);
  const addedANewComment = useSelector((state) => state?.commentsReducer?.addedANewComment);
  const profileData = useSelector((state) => state?.loggedInUserInfo?.userAuthInfo)?.profileInfo;
  const selectedcomment = useSelector((state) => state?.commentsReducer?.selectedcomment);
  const selectedCommentAttachment = useSelector((state) => state?.commentsReducer?.selectedCommentAttachment);
  const deletedFile = useSelector((state) => state?.commentsReducer?.deleteAttachedDocument)
  const deleteCommenttoaster = useSelector((state) => state?.commentsReducer?.deleteCommenttoaster);
  const application_ref_id = useSelector((state) => state?.dashboardDetailReducer?.workFlowInfo?.application_ref_id)
  const applicant_name = useSelector((state) => state?.dashboardDetailReducer?.workFlowInfo?.source_data?.applicant_full_name)
  const subWfId = useSelector((state) => state.urlEncryption?.urlId?.subWfId);
  const [quotedComment, setQuotedComment] = useState(null);

  useEffect(() => {
    if (deleteCommenttoaster) {
      const timeoutId = setTimeout(() => {
        dispatch(resetdeleteCommenttoaster(false));
      }, 3000);
      const commentListContainer = document.getElementById(
        "comment-list-container"
      );
      if (commentListContainer) {
        commentListContainer.scrollTop = 0;
      }
      if (params.primaryWorkflowId !== undefined) {
        const workFlow_id = params.primaryWorkflowId;
        dispatch(resetActivityListState());
        dispatch(
          getActivityListByWorkFlowID({
            workFlow_id,
            start: 0,
            limit: 10,
            sortBy,
            sortOrder,
          })
        );
      }
      setIsEditComment(false);
      setMentionsList([]);
      setcheckcomments(false);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [deleteCommenttoaster]);
  useEffect(() => {
    if (isemptyComment) {
      const timeoutId = setTimeout(() => {
        setIsEmptyComment(false);
      }, 3000);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isemptyComment]);
  useEffect(() => {
    if (Object.keys(selectedcomment).length !== 0) {
      setIsEditComment(true);
    }
  }, [selectedcomment]);
  useEffect(() => {
    // when the component mounts we will fetch the comments and if the user
    //refreshed the screen then we will clear the previous comments
    //reset the state values to default values when the component mounts
    if (params.primaryWorkflowId !== undefined) {
      const workflow_id = params.primaryWorkflowId;
      dispatch(resetCommentsState());
      dispatch(
        getCommentsByWorkFlowId({
          workflow_id,
          start: 0,
          limit,
          sortBy,
          sortOrder,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    // when the comments are fetched we will set the comments in the state
    if (comments) {
      setCommentList(comments);
    }
  }, [comments]);
  useEffect(() => {
    if (!inputFileValue?.name) return;
    // let divElement = document.getElementById("comment-div-id");

    const input = document.getElementById("comment-div-id");
    const lengthOfText = input.innerText.length;

    if (input.innerText.length > 0) {
      const range = document.createRange();
      const sel = window.getSelection();
      range.setStart(input.childNodes[0], lengthOfText);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
      input.focus();
    }
    // divElement.innerHTML =
    //   divElement.innerHTML +
    // ` <a href=\"${inputFileValue.name}\" id="${inputFileValue.name}" target="_blank" >${inputFileValue.name}</a>&nbsp;`;
    // divElement.focus();
  }, [inputFileValue]);
  useEffect(() => {
    if (uploadedListAttachmentOfComments)
      setUploadedList(uploadedListAttachmentOfComments);
  }, [uploadedListAttachmentOfComments]);
  useEffect(() => {
    if (triggerText?.length > 0) {
      timerRef.current = null;
      triggerText?.length >= 1 &&
        timerRef.current === null &&
        (timerRef.current = setTimeout(async () => {
          let res = await getUserFromUsersList(allUsers, triggerText);
          if (res?.length === 0) {
            setShowSuggestion(false);
            dispatch(setUsersSuggestionsList([]));
          }
          setShowSuggestion(true);
          dispatch(setUsersSuggestionsList(res));
          timerRef.current = null;
        }, 500));
    } else {
      setUsersSuggestionsList([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerText]);
  useEffect(() => {
    if (addedANewComment) {
      const timeoutId = setTimeout(() => {
        dispatch(resetAddedNewComment());
      }, 3000);
      const commentListContainer = document.getElementById(
        "comment-list-container"
      );
      if (commentListContainer) {
        commentListContainer.scrollTop = 0;
      }
      setMentionsList([]);
      if (params.primaryWorkflowId !== undefined) {
        const workFlow_id = params.primaryWorkflowId;
        dispatch(resetActivityListState());
        dispatch(
          getActivityListByWorkFlowID({
            workFlow_id,
            start: 0,
            limit: 10,
            sortBy,
            sortOrder,
          })
        );
      }

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [addedANewComment, dispatch]);
  useEffect(() => {
    const commentDiv = document.getElementById("comment-div-id");
    if (commentDiv && Object.keys(selectedcomment).length !== 0) {
      setcheckcomments(true);
      let commentMessage = selectedcomment.message;
      commentDiv.textContent = `${commentMessage}`;
    }
  }, [selectedcomment]);

  const editCommenttoaster = useSelector(
    (state) => state?.commentsReducer?.editCommenttoaster
  );
  useEffect(() => {
    if (editCommenttoaster) {
      const timeoutId = setTimeout(() => {
        dispatch(reseteditCommenttoaster());
      }, 3000);
      const commentListContainer = document.getElementById(
        "comment-list-container"
      );
      if (commentListContainer) {
        commentListContainer.scrollTop = 0;
      }
      setMentionsList([]);
      if (params.primaryWorkflowId !== undefined) {
        const workFlow_id = params.primaryWorkflowId;
        dispatch(resetActivityListState());
        dispatch(
          getActivityListByWorkFlowID({
            workFlow_id,
            start: 0,
            limit: 10,
            sortBy,
            sortOrder,
          })
        );
      }

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [editCommenttoaster]);

  const refreshFunction = (userName, commentId, comment, emailId, attachments) => {
    setQuotedComment({ userName, commentId, comment, emailId, attachments});
  }

  const handleJump = (parentCommentId) => {
    const targetComment = document.getElementById(`comment-${parentCommentId}`);
    if (targetComment) {
      targetComment.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.log("Comment not found");
    }
  };

  const getSuggestions = () => {
    const handleDivClick = (item) => {
      setUsersSuggestionsList([]);
      const divElement = document.getElementById("comment-div-id");
      if (!divElement) {
        console.error("Element with ID 'comment-div-id' not found");
        return;
      }

      const exp = /(@[A-z]*)\w*/i;

      const htmlContent = divElement.innerHTML;
      divElement.innerHTML = htmlContent.replace(
        exp,
        `${item.profile.first_name} ${item.profile.last_name ? `${item.profile.last_name}` : ""
        }`
      );

      const fillteredMentionsList = mentionsList.filter(
        (mention) => mention.email_id !== item.email_id
      );
      setMentionsList([...fillteredMentionsList, item]);
      // console.log(mentionsList)
      setShowSuggestion(false);

      const input = document.getElementById("comment-div-id");
      if (!input) {
        console.error("Element with ID 'comment-div-id' not found");
        return;
      }

      try {
        const range = document.createRange();
        const lengthOfText = input.textContent.length;

        range.setStart(input, lengthOfText);
        range.collapse(true);

        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        input.focus();
      } catch (error) {
        console.error("Error setting range:", error);
      }
    };

    return (
      usersSuggestionList &&
      usersSuggestionList?.length > 0 &&
      usersSuggestionList?.map((item, i) => (
        <Fragment key={i}>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "6px", 
              marginTop: "5px",
            }}
            key={i}
            onClick={() => handleDivClick(item)}
          >
            <p className="profile_name mb-0">
              {item?.profile?.first_name
                ? item?.profile?.first_name[0].toUpperCase()
                : "A"}
              {item?.profile?.last_name
                ? item?.profile?.last_name[0].toUpperCase()
                : ""}
            </p>
            {item?.profile?.first_name +
              " " +
              (item?.profile?.last_name ? item?.profile?.last_name : "")}
          </label>
          <hr className="m-0" />
        </Fragment>
      ))
    );
  };

  function getCaretCharacterOffsetWithin(element) {
    let caretOffset = 0;
    if (typeof window.getSelection !== "undefined") {
      let selection = window.getSelection();
      if (selection.rangeCount > 0) {
        let range = selection.getRangeAt(0);
        let preCaretRange = range.cloneRange();
        preCaretRange.selectNodeContents(element);
        preCaretRange.setEnd(range.endContainer, range.endOffset);
        caretOffset = preCaretRange.toString().length;
      }
    } else if (
      typeof document.selection !== "undefined" &&
      document.selection.type !== "Control"
    ) {
      let textRange = document.selection.createRange();
      let preCaretTextRange = document.body.createTextRange();
      preCaretTextRange.moveToElementText(element);
      preCaretTextRange.setEndPoint("EndToEnd", textRange);
      caretOffset = preCaretTextRange.text.length;
    }
    return caretOffset;
  }

  const handleDivCommentChange = debounceFunc((e) => {
    e.preventDefault();

    const textElement = document.getElementById("comment-div-id");
    const textContent = textElement.textContent;

    if (charCount >= maxChars) return;

    setCharCount(textContent.length);

    if (!textContent) {
      setShowSuggestion(false);
      return;
    }

    const sel = window.getSelection();
    const char = sel.focusNode?.nodeValue?.charAt(sel.focusOffset - 1);
    const caretOffset = getCaretCharacterOffsetWithin(textElement) - 1;

    handleDivKeyDown(char, caretOffset);

    if (showSuggestion) {
      setSuggestionTextPos((prev) => ({
        ...prev,
        end: textContent.length,
      }));

      const triText = textContent;
      const triggerText = triText.substring(
        suggestionTextPos?.start,
        caretOffset + 1
      );
      setTriggerText(triggerText);
    }
  }, 500);

  const handleDivKeyDown = (char, position) => {
    if (char === "@") {
      setShowSuggestion(true);
      setSuggestionTextPos({ start: position + 1, end: position });
    } else if (!/[A-z]/.test(char)) {
      setShowSuggestion(false);
    }
  };

  const handleSuggestionScroll = (e) => {
    const target = e.target;
    // Check if the container is at the top or bottom
    const atTop = target.scrollTop === 0 && e.deltaY < 0;
    const atBottom = target.scrollHeight - target.scrollTop === target.clientHeight && e.deltaY > 0;
    if (atTop || atBottom) {
      e.stopPropagation(); // Stop the event from reaching the parent
      e.preventDefault(); // Prevent default scrolling behavior
    }
  
  };

  const handleSend = async () => {
    let textElement = document.getElementById("comment-div-id");
    if (!textElement.textContent) {
      setIsEmptyComment(true);
      return;
    }

    let comment = textElement.innerHTML;
    let ValidatedComment = comment
      .replace(/<\/?[^>]+(>|$)/g, "")
      .replace(/&nbsp;/g, " ");
    comment =
      (/[\S\r\n]/.test(ValidatedComment) ? " " : "") + ValidatedComment.trim();
    if (comment?.length > 0) {
      const removingDuplicateAndNull = uploadedListAttachmentOfComments.filter(
        (item, index) => {
          return (
            uploadedListAttachmentOfComments.indexOf(item) === index &&
            item !== null
          );
        }
      );
      const mergedNames = mentionsList.map(
        (mention) =>
          mention.profile.first_name + " " + mention.profile.last_name
      );
      const notMentioned = [];

      for (const name of mergedNames) {
        if (!comment.includes(name)) {
          const [firstName, lastName] = name.split(" ");
          notMentioned.push({ firstName, lastName });
        }
      }
      let mentionsForObj = mentionsList; // Default value

      if (notMentioned.length > 0) {
        let val = mentionsList.filter((mention) => {
          return !notMentioned.some(
            (notMentionedName) =>
              mention.profile.first_name === notMentionedName.firstName &&
              mention.profile.last_name === notMentionedName.lastName
          );
        });
        mentionsForObj = val;
      }
      const obj = {
        body: comment,
        workflow_id: workflow_id,
        created_by: profileData?.userId,
        mentions: mentionsForObj,
        attachments: removingDuplicateAndNull,
        userName: profileData?.first_name + "   " + profileData?.last_name,
        userRole: profileData?.role_name
          ? profileData?.role_name
          : profileData?.role,
        trigger: props.trigger ? props.trigger : "mentionedUserInComment",
        organisation_id: organisation_id,
        emailId: profileData?.emailId,
        application_ref_id: application_ref_id,
        applicant_name: applicant_name,
        parentId: quotedComment?.commentId,
        parentBody: quotedComment?.comment,
        parentUsername: quotedComment?.userName,
        parentEmailId: quotedComment?.emailId,
        detailViewModuleId: moduleId
      };
      if (removingDuplicateAndNull.length > 0) {
        dispatch(
          uploadCommentDocument({
            organisation_id,
            workflow_id,
            uploadedListAttachmentOfComments: removingDuplicateAndNull,
          })
        );
      }
      let res = await dispatch(addComment(obj)).unwrap();
      dispatch(clearUploadedListAttachmentOfComments());
      textElement.innerHTML = "";
      setCharCount(0);
    } else {
      setIsEmptyComment(true);
    }
    setQuotedComment(null);
  };

  let uploadedFileDetails;
  const handleFileInput = async (e) => {
    const files = e.target.files;
    setFileValue(files[0]);
    uploadedFileDetails = files[0];
    let fileData = {
      file: uploadedFileDetails,
      userId: profileData?.userId,
      workflowId: workflow_id,
      field_name: "attachments",
      userName: profileData?.first_name + " " + profileData?.last_name,
      organisation_id: organisation_id,
      subworkflow_id: subWfId
    };

    const response = await dispatch(uploadAttachmentOfComments(fileData));
    const data = response?.payload?.responseData
    setimgSrc(`${BASE_URL}/workflow/previewUploadedDocument/${organisation_id}/${profileData?.userId}/${data?.document_type}/${data?.encrypted_filename}/${data?.original_name}`)
    var extension = data?.document_type;
    if (extension == ".pdf") {
      setisPdf(true)
    }
    fileInputRef.current.value = '';
  };

  const handleUploadClick = () => {
    setUploadedList(uploadedListAttachmentOfComments);
    let uploadedFile = document.getElementById("file-upload").click();
  };
  const getAllReUploadedFiles = (
    selectedCommentAttachment,
    uploadedListAttachmentOfComments,
    original_name
  ) => {
    if (
      Array.isArray(selectedCommentAttachment) &&
      Array.isArray(uploadedListAttachmentOfComments)
    ) {
      const mergedUploadedFiles = selectedCommentAttachment.concat(
        uploadedListAttachmentOfComments
      );
      return mergedUploadedFiles
    } else {
      console.error("Error");
    }
  };

  const sendEditedComment = () => {
    let textElement = document.getElementById("comment-div-id");
    if (!textElement.textContent) {
      setIsEmptyComment(true);
      return;
    }
    let comment = textElement.innerHTML;
    let ValidatedComment = comment.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, " ");
    comment = (/[\S\r\n]/.test(ValidatedComment) ? ' ' : '') + ValidatedComment.trim();
    const removingDuplicateAndNull = uploadedListAttachmentOfComments.filter(
      (item, index) => {
        return (
          uploadedListAttachmentOfComments.indexOf(item) === index &&
          item !== null
        );
      }
    );
    if (removingDuplicateAndNull.length > 0) {
      dispatch(uploadCommentDocument({ organisation_id, workflow_id, uploadedListAttachmentOfComments: removingDuplicateAndNull, }));
    }
    let attachments = [];
    if (selectedCommentAttachment.length > 0) {
      if (removingDuplicateAndNull.length > 0) {
        attachments = getAllReUploadedFiles(selectedCommentAttachment, removingDuplicateAndNull, 'original_name');
      } else {
        attachments = selectedCommentAttachment;
      }
    } else if (removingDuplicateAndNull.length > 0) {
      attachments = removingDuplicateAndNull;
    } else {
      attachments = [];
    }
    attachments = attachments.filter(attachment => attachment !== null && attachment !== undefined);
    const obj = {
      _id: selectedcomment._id,
      body: comment,
      workflow_id: workflow_id,
      created_by: profileData?.userId,
      mentions: mentionsList,
      attachments: attachments,
      userName: profileData?.first_name + "   " + profileData?.last_name,
      userRole: profileData?.role_name ? profileData?.role_name : profileData?.role,
      trigger: props.trigger ? props.trigger : "mentionedUserInComment",
      organisation_id: organisation_id,
      application_ref_id: application_ref_id,
      applicant_name: applicant_name,
      emailId: profileData?.emailId,
      parentId: quotedComment?.commentId,
      parentBody: quotedComment?.comment,
      parentUsername: quotedComment?.userName,
      parentEmailId: quotedComment?.emailId,
      detailViewModuleId: moduleId,
      limit: limit,
      start: 0,
    };
    if (deletedFile.length > 0) {
      const filteredAttachments = deleteAnUploadedFile;
      const params = {
        organisation_id: organisation_id,
        workflow_id: workflow_id,
        attachments: filteredAttachments,
      }
      dispatch(deleteAttachments(params))
    }
    if (comment?.length > 0) {
      dispatch(editCommentById(obj));
      setIsEditComment(false);
      const selectedFiles = []
      dispatch(setSelectedCommentAttachment(selectedFiles))
      dispatch(clearSelectedComment())
      setCharCount(0);
      setcheckcomments(false);
      const commentDiv = document.getElementById("comment-div-id");
      let commentMessage = "";
      commentDiv.textContent = `${commentMessage}`;
    } else {
      setIsEmptyComment(true);
    }

  };
  const handleScroll = (e) => {
    // triggers when the user scrolls   i.e 90% to the bottom of the page
    const bottom =
      e.target.scrollTop / (e.target.scrollHeight - e.target.clientHeight);
    if (bottom) {
      if (!loadingComments && start < totalComments) {
        dispatch(
          getCommentsByWorkFlowId({
            workflow_id,
            start,
            limit,
            sortBy,
            sortOrder,
          })
        );
      }
    }
  };
  // delete the uploadede file from the Uploadede file list and update in the redux
  const deleteAnUploadedFile = (encrypted_filename) => {
    // let updatedFileList = uploadedList.filter(
    //   (file) => file.encrypted_filename !== fileId
    // );
    // setUploadedFileList(updatedFileList);
    dispatch(deleteAnUploadedFileFromAttachment(encrypted_filename));
  };
  useEffect(() => {
    if (deletedFile) {
      dispatch(updateAttachments(deletedFile));
    }
  }, [deletedFile]);
  const deleteReUploadedFile = (encrypted_filename) => {
    dispatch(setdeleteAttachedComment(encrypted_filename));
  }

  const uploadedDocsContainer = (uploadedFile) => {
    const { original_name, encrypted_filename } = uploadedFile;
    return (
      <>
        {original_name ? (
          <div>
            <Container
              fluid
              className=".comment-card-containerStyle"
            >
              <Row className="p-3 border-theme-grey rounded-3">
                <Col
                  style={{ fontWeight: "bold" }}
                  title={`${original_name}`}
                  xs={11}
                  lg={11}
                >
                  {
                    // if the length of it is greater than 10 then we have to show the first 10 characters and then ... and close with the extension
                    original_name?.length > 17
                      ? original_name?.substring(0, 17) + "..."
                      : original_name
                  }
                </Col>
                {isModalVisible && <Modal
                  show={true}
                  imgSrc={imgSrc}
                  setShowModal={setIsModalVisible}
                  isPdf={isPdf}
                // custom_value={custom_value}
                ></Modal>}
                <Col xs={1} lg={1} className="text-center">
                  <i
                    class="fa fa-trash cursor-pointer"
                    title="delete uploaded file"
                    onClick={() => deleteAnUploadedFile(encrypted_filename)}
                    style={{ color: "red", cursor: "pointer" }}
                  ></i>
                </Col>
              </Row>
            </Container>
          </div>

        ) : null}
      </>
    );
  };
  const [originalNames, setOriginalNames] = useState([]);
  useEffect(() => {
    if (selectedCommentAttachment && Array.isArray(selectedCommentAttachment)) {
      const names = selectedCommentAttachment.map((attachment) => {
        return attachment;
      });
      setOriginalNames(names);
    }
  }, [selectedCommentAttachment]);
  const editUploadedDocContainer = () => {
    return (
      <div>
        {originalNames?.filter(item => item !== null).length > 0
          && originalNames?.map((name, index) => (
            <Container fluid className=".comment-card-containerStyle bhavana">
              <Row className="p-3 border-theme-grey rounded-3">
                <Col
                  style={{ fontWeight: "bold" }}
                  title={`${name?.original_name}`}
                  xs={11}
                  lg={11}
                >
                  {name?.original_name?.length > 17 ? name?.original_name?.substring(0, 17) + "..." : name?.original_name}
                </Col>
                <Col xs={1} lg={1} className="text-center">
                  <i
                    class="fa fa-trash cursor-pointer"
                    title="delete uploaded file"
                    onClick={() => { deleteReUploadedFile(name?.encrypted_filename) }}
                    style={{ color: "red", cursor: "pointer" }}
                  ></i>
                </Col>
              </Row>
            </Container>
          ))}
      </div>
    );
  };
  const handleClose = () => {
    setShowModal(false);
  };
  return (
    <>
      {showModal && (
        <ImageModal
          show={showModal}
          onHide={handleClose}
          imageSource={imageSource}
          workflow_id={workflow_id}
          original_name={original_filename}
        />
      )}

      {addedANewComment && (
        <Toast
          // onClose = {()=>dispatch(resetAddedNewComment())}
          message="A new comment added successfully!"
          type="success"
          autoClose={3000}
        />
      )}

          {editCommenttoaster && (
              <Toast
                  message="Comment edited successfully!"
                  type="success"
                  autoClose={3000}
              />
          )}

      {isemptyComment && (
        <Toast
          // onClose = {()=>dispatch(resetAddedNewComment())}
          message="Please enter a comment!"
          type="error"
          autoClose={3000}
        />
      )}
      {deleteCommenttoaster && (
        <Toast
          message="Comment deleted successfully!"
          type="success"
          autoClose={10000}
        />
      )}

      {/* {loading && (
        <div className="loader-container">
          <div className="loader" />
        </div>
      )} */}
      {/* <Container className=".comments-container-height overflow-y-scroll" id="comments"> */}
      <div
        className={`shadow-sm bg-white comments-container ${commentList && commentList?.length > 2
          ? 'comments-section-container-height theme-scrollbar'
          : ''
          }`}
        onScroll={handleScroll}
      >
        <div className="align-items-center bg-theme-grey-light-two btn-no-after btn-style-reset d-flex justify-content-between py-3 scroll-margin-125px z-index-1">
          <p className="fs-18px fw-bold m-0 ms-3">Comments</p>
        </div>
        {commentList && commentList?.length > 0 && (
          <div className="comment-container-height theme-scrollbar">
            {commentList?.map((ele, i) => (
              <Fragment key={i}>
                {/* the way comment is displayed if its root or  a reply makes the diff */}
                <div id={`comment-${ele?._id}`}>
                  <CommentMsg
                    comment={ele?.body}
                    userName={ele?.userName}
                    index={i}
                    attachments={ele?.attachments}
                    loadingComments={loadingComments}
                    setShowModal={setShowModal}
                    setImageSource={setImageSource}
                    setOrginalFileName={setOrginalFileName}
                    userRole={ele?.userRole}
                    commentId={ele?._id}
                    createdBy={ele?.created_by}
                    parentId={ele?.parentId}
                    parentBody={ele?.parentBody}
                    parentUsername={ele?.parentUsername}
                    emailId={ele?.emailId}
                    refreshFunction={refreshFunction}
                  />
                </div>
              </Fragment>
            ))}
            {loadingComments && (
              <div
                style={{
                  height: '8vh',
                  display: 'flex',
                  justifyContent: 'center',
                  padding: '2rem'
                }}
              >
                <Spinner animation="grow" variant="primary" />
              </div>
            )}
          </div>
        )}
     
      </div>


      <div  className="bg-white shadow-sm position-sticky bottom-0 pt-3 z-index-10">
      {quotedComment && (
          <div className=".quoted-comment-box row mx-4 bg-comment py-2 rounded-2 mb-2">

            <div className="col-1 d-flex align-items-center justify-content-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="13.5" viewBox="0 0 15.5 13.5">
                <path id="Path_58503" data-name="Path 58503" d="M18.75,16v2a.75.75,0,0,1-1.5,0V16A5.256,5.256,0,0,0,12,10.75H5.811l2.72,2.72a.75.75,0,1,1-1.06,1.061l-4-4a.75.75,0,0,1,0-1.061l4-4A.75.75,0,0,1,8.532,6.531l-2.72,2.72H12A6.758,6.758,0,0,1,18.751,16Z" transform="translate(-3.251 -5.25)" />
              </svg>
            </div>

            <div className=".quoted-comment-left col-10 bg-white py-2 rounded-2 d-flex">
              <div className="quoted-comment-container d-flex " onClick={() => { handleJump(quotedComment?.commentId) }}>
                <p className="profile_name pt-1 h-30px w-30px d-flex align-items-center justify-content-center rounded-circle fs-10px fw-bold m-0">
                  {quotedComment?.userName.trim().split(/\s+/)[0]?.charAt(0).toUpperCase()}
                  {quotedComment?.userName.trim().split(/\s+/)[1]?.charAt(0).toUpperCase()}
                </p>
                <div className="quoted-comment-content">
                  {quotedComment?.comment}
                </div>
              </div>
              {
                quotedComment?.attachments?.length > 0 &&   <div className="ms-auto">
                <svg id="Group_42481" data-name="Group 42481" xmlns="http://www.w3.org/2000/svg" width="23.801" height="28.56" viewBox="0 0 23.801 28.56">
    <g id="Group_34094" data-name="Group 34094" opacity="0.3">
      <path id="Path_24540" data-name="Path 24540" d="M1073.761,1235.86a2.458,2.458,0,0,1-2.454-2.454V1230h-10.964a3.2,3.2,0,0,0-3.2,3.2v19.3a3.2,3.2,0,0,0,3.2,3.2h13.162a3.2,3.2,0,0,0,3.2-3.2v-16.646Z" transform="translate(-1057.14 -1230)" fill="#ffdfb3"/>
    </g>
    <path id="Path_24541" data-name="Path 24541" d="M1181.59,1235.86h-2.946a2.458,2.458,0,0,1-2.454-2.454V1230Z" transform="translate(-1162.023 -1230)" fill="#ff9908"/>
    <path id="Path_24542" data-name="Path 24542" d="M1116.781,1400.6H1101.9a1.911,1.911,0,0,0-1.911,1.911v4.436a1.911,1.911,0,0,0,1.911,1.911h14.88a1.911,1.911,0,0,0,1.911-1.911v-4.436A1.911,1.911,0,0,0,1116.781,1400.6Z" transform="translate(-1094.891 -1380.298)" fill="#ff9908"/>
    <path id="Path_24543" data-name="Path 24543" d="M1130.506,1443.37v.866h-.9v-.866Z" transform="translate(-1120.987 -1417.979)" fill="#fff"/>
    <path id="Path_24544" data-name="Path 24544" d="M1142.556,1423.338a1.016,1.016,0,0,1-.425.379,1.5,1.5,0,0,1-.682.142,1.6,1.6,0,0,1-.991-.293,1.045,1.045,0,0,1-.307-.362,1.074,1.074,0,0,1-.118-.458h.921a.489.489,0,0,0,.144.319.445.445,0,0,0,.316.119.367.367,0,0,0,.263-.09.311.311,0,0,0,.1-.238.311.311,0,0,0-.021-.124.3.3,0,0,0-.068-.1.668.668,0,0,0-.22-.149q-.132-.059-.364-.139a4.66,4.66,0,0,1-.555-.225,1.009,1.009,0,0,1-.369-.325,1.053,1.053,0,0,1,.007-1.11,1.022,1.022,0,0,1,.449-.357,1.631,1.631,0,0,1,.655-.119,1.469,1.469,0,0,1,.952.283,1.088,1.088,0,0,1,.4.762h-.937a.47.47,0,0,0-.13-.281.368.368,0,0,0-.13-.081.388.388,0,0,0-.151-.022.354.354,0,0,0-.245.081.314.314,0,0,0-.074.108.3.3,0,0,0-.02.13.3.3,0,0,0,.02.115.32.32,0,0,0,.064.1.638.638,0,0,0,.209.145c.084.037.206.085.364.142a3.858,3.858,0,0,1,.562.23,1.1,1.1,0,0,1,.375.332.957.957,0,0,1,.157.566A.98.98,0,0,1,1142.556,1423.338Z" transform="translate(-1130.158 -1397.566)" fill="#fff"/>
    <path id="Path_24545" data-name="Path 24545" d="M1165.327,1420.58l.875,2.692.876-2.692H1168l-1.246,3.578h-1.119l-1.24-3.578Z" transform="translate(-1151.636 -1397.901)" fill="#fff"/>
    <path id="Path_24546" data-name="Path 24546" d="M1199.451,1420.481a1.406,1.406,0,0,1,.543.891h-.916a.7.7,0,0,0-.278-.306.886.886,0,0,0-1.109.157,1.07,1.07,0,0,0-.248.746,1.092,1.092,0,0,0,.261.784.976.976,0,0,0,.342.215,1,1,0,0,0,.4.058.893.893,0,0,0,.541-.17.9.9,0,0,0,.33-.483h-1.094v-.623h1.817v.856a1.758,1.758,0,0,1-.324.582,1.683,1.683,0,0,1-.57.436,1.814,1.814,0,0,1-.791.167,1.884,1.884,0,0,1-.952-.23,1.573,1.573,0,0,1-.625-.646,2.156,2.156,0,0,1,0-1.9,1.581,1.581,0,0,1,.622-.646,1.847,1.847,0,0,1,.939-.23A1.782,1.782,0,0,1,1199.451,1420.481Z" transform="translate(-1179.966 -1397.514)" fill="#fff"/>
    <g id="Group_44225" data-name="Group 44225" transform="translate(2.465 10.033)">
      <path id="Path_24547" data-name="Path 24547" d="M1108.7,1322.005h-.3a4.53,4.53,0,0,0-9.059,0h-.3a4.827,4.827,0,0,1,9.653,0Z" transform="translate(-1096.528 -1316.837)" fill="#d68107"/>
      <path id="Path_24548" data-name="Path 24548" d="M1095.7,1317.18H1081.98v.3H1095.7Z" transform="translate(-1081.489 -1316.837)" fill="#d68107"/>
      <path id="Path_24549" data-name="Path 24549" d="M1097.259,1353.75h-.948v.948h.948Z" transform="translate(-1094.115 -1349.056)" fill="#d68107"/>
      <path id="Path_24550" data-name="Path 24550" d="M1175.878,1353.75h-.948v.948h.948Z" transform="translate(-1163.379 -1349.056)" fill="#d68107"/>
      <path id="Path_24551" data-name="Path 24551" d="M1136.568,1314.31h-.948v.948h.948Z" transform="translate(-1128.745 -1314.31)" fill="#d68107"/>
      <path id="Path_24552" data-name="Path 24552" d="M1078.335,1315.26a.475.475,0,1,0-.475-.475A.475.475,0,0,0,1078.335,1315.26Z" transform="translate(-1077.86 -1314.31)" fill="#d68107"/>
      <path id="Path_24553" data-name="Path 24553" d="M1193.345,1315.26a.475.475,0,1,0-.475-.475A.475.475,0,0,0,1193.345,1315.26Z" transform="translate(-1179.183 -1314.31)" fill="#d68107"/>
    </g>
                </svg>
                </div>
              }
            </div>

            <div className=".quoted-comment-close col-1 d-flex align-items-center justify-content-center">
              <button onClick={() => setQuotedComment(null)} className="h-28px w-28p rounded-circle bg-white d-flex align-items-center justify-content-center ms-3 btn p-0 border-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                </svg>
              </button>
            </div>

          </div>
        )}
        <Row className="align-items-center outline-0 border-light-grey border border-2 bg-white rounded-2 mx-3" >

          <Col
            xs={{ span: 8, order: 0 }}
            lg={{ span: 9, order: 0 }}
            xxl={{ span: 9, order: 0 }}
          >
            <div
              className="w-100 outline-0 border-grey border-theme rounded-2 p-2"
              rows={1}
              id="comment-div-id"
              contentEditable={!isUploadAttachmentOfCommentsLoading}
              onInput={(e) => {
                let textElement = e.target;
                let textContent = textElement.textContent;
                let sel = window.getSelection();
                let range = sel.getRangeAt(0);
                setCharCount(textContent.length);

                if (textContent.length >= maxChars) {
                  if (e.inputType !== 'deleteContentBackward') {
                    e.preventDefault();
                    textElement.textContent =
                      textContent.substring(0, maxChars);
                    setCharCount(maxChars);
                    range.setEnd(
                      textElement.childNodes[0],
                      maxChars
                    );
                    range.collapse(false);
                    sel.removeAllRanges();
                    sel.addRange(range);
                  } else if (
                    sel.focusOffset === textContent.length
                  ) {
                    range.setEnd(
                      textElement.childNodes[0],
                      maxChars
                    );
                    range.collapse(false);
                    sel.removeAllRanges();
                    sel.addRange(range);
                  }
                }

                handleDivCommentChange(e);
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  if (
                    e.target.textContent.trim() !== '' &&
                    isEditComment
                  ) {
                    sendEditedComment();
                  } else if (
                    e.target.textContent.trim() !== '' &&
                    !isEditComment
                  ) {
                    handleSend();
                  }
                }
              }}
            ></div>
          </Col>

          


          <Col lg={{ span: 2, order: 3 }} style={{ display: 'none' }}>
            <input
              ref={fileInputRef}
              id="file-upload"
              type={'file'}
              accept=".jpg, .png, .jpeg"
              onChange={handleFileInput}
            />
          </Col>

          <Col
            xs={{ span: 4, order: 1 }}
            lg={{ span: 3, order: 2 }}
            xxl={{ span: 3, order: 1 }}
          >
            {!checkcomments && (
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-1">
                {/* <Image
                                    onClick={handleUploadClick}
                                    src={UploadFile}
                                    title="Upload file"
                                    className="h-30px cursor-pointer"
                                    // style={{
                                    //   cursor: "pointer",
                                    //   height: "25px",
                                    //   width: "25px",
                                    //   marginLeft: "10px",
                                    // }}
                                /> */}
                <div
                  className="pt-2 .flex-grow-1 text-center text-md-start "
                >
                  {/* style={{
                    position: 'relative',
                    bottom: 0,
                    right: 0,
                    paddingLeft: '3px',
                    color: charCount >= maxChars ? 'red' : 'inherit',
                    flex: 1,
                  }} */}
                  {charCount}/{maxChars}
                </div>

                <button
                  className="btn btn-white shadow-none border-0 p-0 me-3"
                  onClick={handleUploadClick}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 21.591 19.828"
                    fill="currentColor"
                    className="text-theme stroke-theme"
                  >
                    <g
                      id="Component_101_16"
                      data-name="Component 101 – 16"
                      transform="translate(0.25 0.25)"
                    >
                      <path
                        id="Path_53896"
                        data-name="Path 53896"
                        d="M139.173,103.146a5.278,5.278,0,0,0,7.471,0l11.01-11.01a3.614,3.614,0,0,0-5.112-5.111l-11.01,11.01a1.946,1.946,0,1,0,2.753,2.752l10.224-10.223a.278.278,0,1,0-.393-.393l-10.224,10.223a1.39,1.39,0,1,1-1.966-1.966l11.01-11.01a3.059,3.059,0,0,1,4.326,4.325l-11.01,11.01a4.727,4.727,0,0,1-6.685-6.684L149.79,85.845h0a.278.278,0,1,0-.393-.393L139.173,95.676a5.277,5.277,0,0,0,0,7.471Z"
                        transform="translate(-137.623 -85.368)"
                        stroke-width="0.5"
                      />
                    </g>
                  </svg>
                </button>
                {/* <Image
                                    onClick={handleSend}
                                    title="Send"
                                    className="h-30px ms-3 cursor-pointer"
                                    src={Send2x}
                                /> */}
                <button
                  className="btn btn-white shadow-none border-0 p-0"
                  onClick={handleSend}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 21.39 20.499"
                    fill="currentColor"
                    className="text-theme"
                  >
                    <path
                      id="Send"
                      d="M19.934,9.055,1.033.068a.717.717,0,0,0-.869.21.762.762,0,0,0-.017.92S4.21,6.076,6.239,8.862c.043.059,3.939.872,3.939.872s-3.9.8-3.939.852C4.208,13.377.146,18.272.146,18.272a.765.765,0,0,0,.016.92.717.717,0,0,0,.566.279.7.7,0,0,0,.3-.069l18.9-8.987a.759.759,0,0,0,0-1.36Z"
                      transform="translate(0.534 0.528)"
                      stroke="rgba(0,0,0,0)"
                      stroke-width="1"
                    />
                  </svg>
                </button>
              </div>
            )}

            {checkcomments && (
              <div className="d-flex align-items-center justify-content-between flex-wrap ">
                <div
                  className="pt-2 flex-grow-1 text-center text-md-start"
                  style={{
                    position: 'relative',
                    bottom: 0,
                    right: 0,
                    paddingLeft: '3px',
                    color: charCount >= maxChars ? 'red' : 'inherit',
                    flex: '1',
                  }}
                >
                  {charCount}/{maxChars}
                </div >
                {/* <Image
                                    onClick={handleUploadClick}
                                    src={UploadFile}
                                    title="Upload file"
                                    className="h-30px cursor-pointer"
                                /> */}
                <div className="pt-2 flex-grow-1 text-center text-md-start">
                  <button
                    className="btn btn-white shadow-none border-0 p-0"
                    onClick={handleUploadClick}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 21.591 19.828"
                      fill="currentColor"
                      className="text-theme stroke-theme"
                    >
                      <g
                        id="Component_101_16"
                        data-name="Component 101 – 16"
                        transform="translate(0.25 0.25)"
                      >
                        <path
                          id="Path_53896"
                          data-name="Path 53896"
                          d="M139.173,103.146a5.278,5.278,0,0,0,7.471,0l11.01-11.01a3.614,3.614,0,0,0-5.112-5.111l-11.01,11.01a1.946,1.946,0,1,0,2.753,2.752l10.224-10.223a.278.278,0,1,0-.393-.393l-10.224,10.223a1.39,1.39,0,1,1-1.966-1.966l11.01-11.01a3.059,3.059,0,0,1,4.326,4.325l-11.01,11.01a4.727,4.727,0,0,1-6.685-6.684L149.79,85.845h0a.278.278,0,1,0-.393-.393L139.173,95.676a5.277,5.277,0,0,0,0,7.471Z"
                          transform="translate(-137.623 -85.368)"
                          stroke-width="0.5"
                        />
                      </g>
                    </svg>
                  </button>
                </div>

                {/* <Image
                                    onClick={sendEditedComment}
                                    title="Send"
                                    className="h-30px ms-3 cursor-pointer"
                                    src={Send2x}
                                /> */}

                <div className="pt-2 flex-grow-1 text-center text-md-start">
                  <button
                    className="btn btn-white shadow-none border-0 p-0"
                    onClick={sendEditedComment}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 21.39 20.499"
                      fill="currentColor"
                      className="text-theme"
                    >
                      <path
                        id="Send"
                        d="M19.934,9.055,1.033.068a.717.717,0,0,0-.869.21.762.762,0,0,0-.017.92S4.21,6.076,6.239,8.862c.043.059,3.939.872,3.939.872s-3.9.8-3.939.852C4.208,13.377.146,18.272.146,18.272a.765.765,0,0,0,.016.92.717.717,0,0,0,.566.279.7.7,0,0,0,.3-.069l18.9-8.987a.759.759,0,0,0,0-1.36Z"
                        transform="translate(0.534 0.528)"
                        stroke="rgba(0,0,0,0)"
                        stroke-width="1"
                      />
                    </svg>
                  </button>
                </div>

              </div>
            )}
          </Col>
        </Row>


        {/* <Button className="mx-2" onClick={handleUploadClick}>
              {isUploadAttachmentOfCommentsLoading ? "Loading..." : "Upload"}
            </Button> */}

        {/* <Button onClick={handleSend}>Send</Button> */}
        {/* <label className="comment-sub-text px-3">
          Type ‘@‘ and the name of the person to address a remark to
          them
        </label> */}
        <Container>

          {showSuggestion &&
              triggerText.length >= 1 &&
              usersSuggestionList?.length > 0 && (
                <Col xs={12}>
                  <div className="suggestion-container" 
                  style={{ height: "170px", overflowY: "auto", scrollbarWidth: "thin" }} 
                  onWheel={handleSuggestionScroll}
                >
                    {getSuggestions()}
                  </div>
                </Col>
              )}
        </Container>
        <Container>
          <Row className="mt-1">
            {uploadedList.length > 0 &&
              uploadedList.map((ele, index) =>
                ele?.encrypted_filename
                  ? uploadedDocsContainer(ele)
                  : null
              )}
          </Row>
        </Container>
        {selectedCommentAttachment.length > 0 && (
          <Row className="mt-1">{editUploadedDocContainer()}</Row>
        )}
      </div>

      {/* <button onClick={() => pasteHtmlAtCaret(`<b>hi</b>`)}>paste</button> */}
      {/* </Container> */}
    </>
  );
};

export default CommentTextArea;
